import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home.vue"
import Login from "./views/Login.vue"
import store from "./store"
import account from "./views/Account"
import Form from "./views/Form"
import patients from "./views/patients"
import tasks from "./views/Tasks"
import task from "./views/Task"
import users from './views/Users'
import user from './views/User'
import ipwhitelisted from "./views/public/ipwhitelisted"
import myMessage from "./views/myMessage"
import messageCenter from "./views/messageCenter"
import viewMessage from "./components/message/viewMessage"
import history from "./views/history"
import groupNotifications from "./views/GroupNotifications.vue"
import emailEditor from "./components/emailEditor"
import settings from "./views/settings"
Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/public/response/ipwhitelisted",
      name: "ipwhitelisted",
      component: ipwhitelisted
    },
    {
      path: "/",
      name: "login",
      component: Login
    },
    {
      path: "/admin/myMessage",
      name: "messgaeCenter",
      component: myMessage,
      meta: { requiresAuth: true }
    },
    {
      path: "/message/view/:id",
      name: "viewMessage",
      component: viewMessage,
      meta: { requiresAuth: true }
    },
    {
      path: "/home",
      name: "home",
      component: Home,
      meta: { requiresAuth: true }
    },
    {
      path: "/account",
      name: "account",
      component: account,
      meta: { requiresAuth: true }
    },
    {
      path: "/users",
      name: "users",
      component: users,
      meta: { requiresAuth: true }
    },
    {
      path: "/messageCenter",
      name: "messageCenter",
      component: messageCenter,
      meta: { requiresAuth: true }
    },
    {
      path: "/tasks",
      name: "tasks",
      component: tasks,
      meta: { requiresAuth: true }
    },
    {
      path: "/patients",
      name: "patients",
      component: patients,
      meta: { requiresAuth: true }
    },
    {
      path: "/emailEditor",
      name: "emailEditor",
      component: emailEditor,
      meta: { requiresAuth: true }
    },
    {
      path: "/form/:formType",
      name: "form",
      component: Form,
      meta: { requiresAuth: true }
    },
    {
      path: "/history",
      name: "history",
      component: history,
      meta: { requiresAuth: true }
    },
    {
      path: "/settings",
      name: "settings",
      component: settings,
      meta: { requiresAuth: true }
    },
    {
      path: "/groupNotifications",
      name: "groupNotifications",
      component: groupNotifications,
      meta: { requiresAuth: true }
    },
    {
      path: "/task/:tasktype/:taskId/:id",
      name: "task",
      component: task,
      meta: { requiresAuth: true }
    },
    {
      path: "/user/:type/:value",
      name: "user",
      component: user,
      meta: { requiresAuth: true }
    },
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (store.getters.isLoggedIn) {
      next()
      return
    } else {
      next({
        path: "/"
      })
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router
